import DetailTenant from './DetailTenant';

export default DetailTenant;
